import { getDomainKey } from "./domains";

// Tokens look like [[mobility.2]]: <domain key>.<principle index within the domain>
const PRINCIPLE_TOKEN_REGEX = /[ \t]*\[\[\s*([^\][.\s]+)\.(\d+)\s*\]\]/g;

export const PRINCIPLE_REF_TAG = "principle-ref";

export const principleAnchorId = (domainName: string, index: number | string): string =>
  `principle-${getDomainKey(domainName)}-${index}`;

export const stripPrincipleTokens = (summary?: string): string =>
  (summary ?? "").replace(PRINCIPLE_TOKEN_REGEX, "");

export type PrincipleDomainRef = { domain_name: string; category?: number };

export const findDomainOfPrinciple = (
  groups: any[] | undefined,
  domainKey: string,
  index: number
): PrincipleDomainRef | undefined => {
  const wantedKey = getDomainKey(domainKey);
  for (const group of groups ?? []) {
    for (const domain of group?.domains ?? []) {
      const hasPrinciple = (domain?.principles ?? []).some((p: any) => Number(p?.index) === index);
      if (hasPrinciple && getDomainKey(domain?.domain_name) === wantedKey) {
        return domain;
      }
    }
  }
  return undefined;
};

// Valid tokens become <principle-ref> markers (rendered as icons), unknown ones are dropped.
export const injectPrincipleMarkers = (summary: string | undefined, groups: any[] | undefined): string => (
  (summary ?? "").replace(PRINCIPLE_TOKEN_REGEX, (_match, domainKey: string, index: string) =>
    findDomainOfPrinciple(groups, domainKey, Number(index))
      ? ` <${PRINCIPLE_REF_TAG} data-token="${domainKey}.${index}"></${PRINCIPLE_REF_TAG}>`
      : ""
  ));


export const scrollToPrinciple = (anchorId: string) => {
  const item = document.getElementById(anchorId);
  if (!item) {
    return;
  }
  const trigger = item.querySelector("button") as HTMLElement | null;
  const offset = document.querySelector(".root-layout > div:first-child")?.getBoundingClientRect()?.height || 0;
  const targetPosition = item.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - (offset + 50);
  window.scrollTo({ top: targetPosition, behavior: "smooth" });
  if (trigger?.getAttribute("data-state") === "closed") {
    trigger.click();
  }
};
